import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

export const LockedInternalSection = () => {
  const {
    values: {
      anotherEventButtonEnabled,
      anotherEventButtonLabel,
      customLinks
    }
  } = useFormContext()

  const enabledLinkContents = customLinks
    ? customLinks.filter(({ enabled }) => enabled).map(({ content }) => content)
    : []

  if (anotherEventButtonEnabled) {
    enabledLinkContents.push(anotherEventButtonLabel)
  }

  return (
    <>
      <BodyText>
        {I18n.t('publisher.event_type_editor.sections.more_options.confirmation_page.helper_text')}
      </BodyText>
      <BodyText weight="bold">
        {I18n.t('publisher.event_type_editor.sections.booking_page_options.confirmation_page.links_on_confirmation_page')}
      </BodyText>
      {
        enabledLinkContents.length > 0
          ? enabledLinkContents.map((content) => <BodyText key={content}>{content}</BodyText>)
          : <BodyText>{I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.buffer.none')}</BodyText>
      }
    </>
  )
}
